import InputsSection from './InputsSection'

export * from './InputsSection'

export default InputsSection
